import {EventListener} from "@k/global/eventVerteiler";
import {displayFadeoutMessageToUser} from "@km/components/popups/MessageToDisplayContainer";
import {INTERFRAMEMESSAGES} from "@k/global/InterframeMessages";

export function initShopMessageEventListeners(translate:(string:string)=>string) {
    const e = new EventListener();
    e.addEventListener("produkteSpeichernErfolgreich", ()=>displayFadeoutMessageToUser(translate("shop_speichernErfolgreich")));
    e.addEventListener(INTERFRAMEMESSAGES.WARENKORB_CHANGED, ()=>displayFadeoutMessageToUser(translate("shop_SavedInBasket")));
}
